<template>
  <el-container direction="vertical" id="quotationDetails">
    <el-row style="padding: 40px 0 50px;">
      <el-col :span="16" :push="4" class="cardList" style="padding: 60px 80px;margin: 0 auto" v-loading="loading">
        <div class="grid-content">
          <div class="title">产品方案报价书</div>
          <div class="titleTranslate">Product proposal quotation</div>
        </div>
        <div class="remarks">
          尊敬的用户，感谢您选择小白保险提供的团险服务，以下是您的专属保障计划
        </div>
        <div class="statistics space-around">
          <div>
            <div class="statisticsTitle">保险期限</div>
            <div class="statisticsValue">12个月</div>
          </div>
          <div>
            <div class="statisticsTitle">投保人数</div>
            <div class="statisticsValue">{{quoteMainInfo.groupSizeSum}}人</div>
          </div>
          <div>
            <div class="statisticsTitle">人均保费</div>
            <div class="statisticsValue">{{quoteMainInfo.averagePremium}}元</div>
          </div>
          <div>
            <div class="statisticsTitle">总保费</div>
            <div class="statisticsValue" style="color: #528BFF">{{quoteMainInfo.discountPremium}}元</div>
          </div>
        </div>
        <div class="planTitle">
          <span></span><div>// 保障计划 //</div><span> </span>
        </div>
        <ul class="planList flex-wrap">
          <li v-for="(quote, key, index) in quoteDetailList" :class="key%2==0?'planLeft':'planRight'">
            <div>
              <div class="supportPlan"><div class="title">保障计划{{numText(key)}}</div></div>
              <div class="typeLine">
                <div class="typeTitle">投保职业</div>
                <div class="typeValue"><label style="color: #333333">{{quote.ThreeName}}</label></div>
              </div>
              <div class="typeLine">
                <div class="typeTitle">职业类别</div>
                <div class="typeValue"><label style="color: #333333">{{quote.azcnCode}}类</label></div>
              </div>
              <div class="typeLine">
                <div class="typeTitle">投保人数</div>
                <div class="typeValue">{{quote.groupSize}}</div>
              </div>
              <div class="typeLine" v-for="skuData in quote.skuList" v-if="skuData.type !== 1 && skuData.type !== 4 && skuData.type !== 6">
                <div class="typeTitle">{{skuData.name}}</div>
                <div class="typeValue">{{skuData.specName}}</div>
              </div>
              <div class="typeLine">
                <div class="typeTitle">保费</div>
                <div class="typeValue">{{quote.premium}}元</div>
              </div>
              <div style="font-size: 1rem;color: #FF7052">
                <div>免赔额：</div>
                <div>1、意外伤害医疗免赔100元后按80%比例赔付</div>
                <div>2、意外住院津贴免赔3天</div>
              </div>
            </div>
          </li>
        </ul>
        <div class="planTitle">
          <span></span><div>// 保障权益 //</div><span> </span>
        </div>
        <div class="interestProtection" v-for="(quote, key, index) in skuSpecList">
          <div class="title" v-if="key == 3">{{quote.name}}</div>
          <div class="content" v-if="key == 3">{{quote.remark}}</div>
          <div class="title" v-if="key == 4">{{quote.name}}</div>
          <div class="content" v-if="key == 4">{{quote.remark}}</div>
          <div class="title" v-if="key == 5">{{quote.name}}</div>
          <div class="content" v-if="key == 5">{{quote.remark}}</div>
        </div>
        <div style="width: 100%;text-align: center;">
          <el-button type="danger" style="width: 160px;height: 40px;background: #FF7052;border-radius: 12px;margin-top: 50px" @click="onPdf">下载报价书</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center" style="padding-bottom: 80px">
      <el-col :span="16">
        <template>
          <el-tabs v-model="activeName">
            <el-tab-pane label="产品简介" name="first" v-html="insuranceInfo.unscramble"></el-tab-pane>
            <el-tab-pane label="投保须知" name="second" v-html="insuranceInfo.ensureExplainContent"></el-tab-pane>
            <el-tab-pane label="理赔服务" name="third" v-html="insuranceInfo.claimsServices"></el-tab-pane>
            <el-tab-pane label="常见问题" name="four" v-html="insuranceInfo.commonProblem"></el-tab-pane>
          </el-tabs>
        </template>
      </el-col>
    </el-row>
  </el-container>
</template>

<script>
    export default {
        name: "quotationDetails",
        data(){
          return{
            formInline:{
              quoteMainId:'',
              memberId:'',
              userMember:''
            },
            activeName: 'first',
            loading: false,
            quoteDetailList:[],
            quoteMainInfo:{
              discountPremium:0,
              groupSizeSum:0,
              averagePremium:0,
              pdfUrl: ''
            },
            insuranceInfo: {
              unscramble:'',
              ensureExplainContent:'',
              claimsServices:'',
              commonProblem:''
            },
            textArr:[
              {name:9,value:'十'},
              {name:0,value:'一'},
              {name:1,value:'二'},
              {name:2,value:'三'},
              {name:3,value:'四'},
              {name:4,value:'五'},
              {name:5,value:'六'},
              {name:6,value:'七'},
              {name:7,value:'八'},
              {name:8,value:'九'}
            ],
            skuSpecList: [],
          }
        },
        methods:{
          getSkuInfo() {
            this.axios.post('/management/mobileInsuranceInfo/getInsuranceSkuDetail?insuranceInfoId=' + 100414 + '&planId=' + 1667, {}).then((response) => {
              let data = response.data;
              if (data.success) {
                this.skuSpecList = data.datas.skuSpecList;
              } else {
                this.$message.error(data.msg);
              }
            });
          },
          numText(num){
            let numArr = num.toString().split('');
            let that = this;
            let result  = [];
            numArr.forEach(res=>{
              that.textArr.forEach(item=>{
                if(item.name==res){ result.push(item.value) }
              })
            })
            return result.join('');
          },
          onPdf(){
            window.location.href = this.quoteMainInfo.pdfUrl;
          },
          getQuotationDetails() {
            this.loading = true;
            this.axios.post('/management/quotedetailinfo/getQuoteDetailListByMainId', {
              quoteMainId: this.formInline.quoteMainId,
              userMember: this.formInline.userMember,
            }).then((response) => {
              if(response.data.success){
                this.quoteDetailList = response.data.quoteDetailList;
                this.quoteMainInfo = response.data.quoteMainInfo;
                this.quoteMainInfo.groupSizeSum = response.data.groupSizeSum;
                this.quoteMainInfo.averagePremium = this.$$.div(this.quoteMainInfo.discountPremium, this.quoteMainInfo.groupSizeSum).toFixed(2);
                this.getInsurance(this.quoteMainInfo.productId);
              }
              this.loading = false;
            })
          },
          //-- 获取 - 产品详情
          getInsurance(insuranceInfoId) {
            this.axios.post('/management/mobileInsuranceInfo/getInsurance?insuranceInfoId='+insuranceInfoId).then((response) => {
              if(response.data.success){
                const {claimsServices, commonProblem, ensureExplainContent, unscramble} = response.data.datas;
                this.insuranceInfo = {
                  unscramble,
                  ensureExplainContent,
                  claimsServices,
                  commonProblem
                };
              }
            })
          },
        },
        mounted() {
          this.formInline.quoteMainId = this.$route.params.quoteMainId;
          this.formInline.userMember = this.$route.params.userMember;
          this.getQuotationDetails();
          this.getSkuInfo();
        }
    }
</script>

<style scoped>
  .cardList{
    background-color: #ffffff;
    box-shadow: 0px 12px 28px 0px rgba(204, 204, 204, 0.25);
  }
  .grid-content{
    text-align: center;
  }
  .grid-content .title{
    font-size: 40px;
    font-weight: bold;
    color: #333333;
    letter-spacing:2px;
  }
  .grid-content .titleTranslate{
    font-size: 12px;
    font-weight: 500;
    color: #999999;
    letter-spacing:2px;
  }
  .remarks{
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    margin-top: 60px;
  }
  .statistics{
    padding: 20px 0;
    margin-top: 20px;
    border: 2px solid #CCCCCC;
    border-radius: 16px;
    display: flex;
    flex-flow: row wrap;
    align-content: flex-start;
    text-align: center;
  }
  .statistics .statisticsTitle{
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    margin-bottom: 5px;
  }
  .statistics .statisticsValue{
    font-size: 20px;
    font-weight: 500;
    color: #FF7052;
  }
  .planTitle{
    margin: 30px auto 0;
    text-align: center;
  }
  .planTitle>div{
    text-align: center;
    font-size: 28px;
    font-weight: bold;
    color: #333333;
    display: inline-block;
    padding: 0 10px;
  }
  .planTitle>span{
    color: #CCCCCC;
    display: inline-block;
    width: calc((100% - 210px) / 2);
    border-top: 1px solid #cccccc;
    vertical-align: 5px;
  }

  .planList{
    width: 100%;
    margin: 0 auto;
  }

  .planList>li {
    min-width: 400px;
    padding-right: 5rem;
  }
  .planList>li>div{
    width: 400px;
    margin-top: 30px;
  }

  .supportPlan {
    width: 120px;
    height: 12px;
    background: #FFBF00;
    font-size: 24px;
    font-weight: bold;
    color: #333333;
    text-align: center;
    margin-bottom: 20px;
    display: inline-block;
    position: relative;
  }
  .planList .planLeft .title{
    position: absolute;
    left: 0;
    top: -20px;
  }
  .planList .planRight .title{
    position: absolute;
    left: 0;
    top: -20px;
  }
  .planList .planLeft .typeLine,
  .planList .planRight .typeLine{
    display: flex;
    flex-flow: row wrap;
    align-content: flex-start;
    width: 100%;
    margin-bottom: 10px;
  }

  .planList .planLeft .typeTitle{
    width: 50%;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
  }
  .planList .planLeft .typeValue{
    width: 50%;
    text-align: right;
    font-size: 16px;
    font-weight: 400;
    color: #FF7052;
  }
  .planList .planRight .typeTitle{
    width: 50%;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
  }
  .planList .planRight .typeValue{
    width: 50%;
    text-align: right;
    font-size: 16px;
    font-weight: 400;
    color: #FF7052;
  }

  .interestProtection{
    width: 100%;
    margin: 0 auto;
  }

  .interestProtection>.title{
    font-size: 16px;
    font-weight: bold;
    color: #333333;
  }

  .interestProtection>.content{
    font-size: 15px;
    font-weight: 400;
    color: #666666;
    margin: 10px auto 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/chinaLifeAccidentInsurance/quotationDetails.vue